import { ButtonState, ButtonStateProps } from './EmployerInterviewButton.types';
import { ArrowRightLongIcon, CalendarIcon, CheckIcon, CloseIcon } from 'icons/outline';

export const ButtonStateToData = new Map<ButtonState, ButtonStateProps>([
  [
    ButtonState.DEFAULT,
    {
      button: {
        variant: 'solid',
        icon: CalendarIcon,
        label: 'Invite to Interview',
      },
    },
  ],
  [
    ButtonState.INVITATION_SENT,
    {
      button: {
        variant: 'outline',
        icon: CheckIcon,
        label: 'Invite Sent!',
        btnClassName:
          'enabled:!bg-secondary-sky enabled:!text-primary-pure-blue enabled:!border-primary-pure-blue !cursor-not-allowed',
      },
      message: {
        icon: ArrowRightLongIcon,
        messageClassName: 'text-neutral-dark bg-neutral-no-gray',
        prefix: 'Sent on',
        preventInvite: true,
      },
    },
  ],
  [
    ButtonState.INTERVIEW_CANCELED,
    {
      button: {
        variant: 'outline',
        icon: CalendarIcon,
        label: 'Send New Invite',
      },
      message: {
        icon: CloseIcon,
        messageClassName: 'text-primary-poppy-red bg-tertiary-red-200',
        prefix: 'Interview Canceled',
      },
    },
  ],
  [
    ButtonState.INTERVIEW_SCHEDULED,
    {
      button: {
        variant: 'outline',
        icon: CheckIcon,
        label: 'Invite Sent!',
        btnClassName:
          'enabled:!bg-secondary-sky enabled:!text-primary-pure-blue enabled:!border-primary-pure-blue !cursor-not-allowed',
      },
      message: {
        icon: CheckIcon,
        messageClassName: 'text-neutral-dark bg-neutral-no-gray',
        prefix: 'Scheduled on',
        preventInvite: true,
      },
    },
  ],
  [
    ButtonState.INTERVIEW_ATTENDED,
    {
      button: {
        variant: 'solid',
        icon: CalendarIcon,
        label: 'Invite to Interview',
      },
      message: {
        icon: CheckIcon,
        messageClassName: 'text-neutral-dark bg-neutral-no-gray',
        prefix: 'Attended on',
      },
    },
  ],
]);
